import React from 'react'
import moment from 'moment'
import { Tooltip } from 'antd'
import { Link } from 'react-router-dom'

function ProductionStageRow(props) {
    const { item } = props
    const { _id, name, partner, created, updated, } = { ...item }

    const { name: partnerName } = { ...partner }

    return (
        <tr>
            <td>{name}</td>
            {/* <td>Key</td> */}
            <td>{partnerName}</td>
            {/* <td>
                <Switch onClick={() => handleChangeStatus()} />
            </td> */}
            <td>{created ? moment(created).format('HH:mm DD/MM/YYYY') : ''}</td>
            <td>{updated ? moment(updated).format('HH:mm DD/MM/YYYY') : ''}</td>
            <td>
                <Tooltip title='Chỉnh sửa'>
                    <Link to={`/production-stage/${_id}`}><i className="icon-pencil text-primary mx-1" /></Link>
                </Tooltip>
                {/* <Tooltip title='Delete'>
                    <span className="text-danger mx-1 cursor-pointer"
                        onClick={(e) => handleClickDelete(e, _id)}
                    >
                        <i className="icon-bin text-danger mx-1" />
                    </span>
                </Tooltip> */}
            </td>
        </tr>
    )
}

export default ProductionStageRow